import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { route } from '../../route/Index';
import Span from '../../shared/component/Span';
import { cleanAlert } from '../../store/alert/alertSlice';
import { useAppDispatch } from '../../store/hook';
import { cleanProject } from '../../store/project/projectSlice';
import { cleanResult } from '../../store/result/resultSlice';
import { cleanImage } from '../../store/Image/imageSlice';

interface IBackofficeProps {}

const Backoffice = (props: IBackofficeProps) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(cleanResult());
        dispatch(cleanImage());
        dispatch(cleanProject());
        dispatch(cleanAlert());
        navigate(route.backoffice);
    };

    return (
        <Button variant='greenLight' startIcon={<EditIcon />} onClick={handleClick}>
            <Span text={t('backoffice')} />
        </Button>
    );
};

export default Backoffice;
